import { ComponentProps } from 'react';
import { connect } from 'react-redux';
import { getAppLocale } from '../../../../selectors/app';
import {
    getCalendarType,
    getSelectedSessionId,
    getTimezone,
} from '../../../../selectors/infiniteCalendarSeries/infiniteCalendarSeries';
import { CheckoutState } from '../../../../state';
import type { InfiniteCalendarSeriesNamespace } from '../../../../state/infiniteCalendarSeries';
import { normalizeLocale } from '../../../../utils/general';
import TimeSlotSelector from './TimeSlotSelector';

export type TimeSlotSelectorStateProps = Pick<
    InfiniteCalendarSeriesNamespace,
    'selectedSessionId' | 'calendarType' | 'locale' | 'timezone'
>;

export const connectTimeSlotSelector = () =>
    connect(
        (state: CheckoutState): TimeSlotSelectorStateProps => ({
            selectedSessionId: getSelectedSessionId(state),
            calendarType: getCalendarType(state),
            locale: normalizeLocale(getAppLocale(state)),
            timezone: getTimezone(state),
        }),

        (
            stateProps: TimeSlotSelectorStateProps,
            ownProps: Omit<
                ComponentProps<typeof TimeSlotSelector>,
                keyof TimeSlotSelectorStateProps
            >,
        ) => ({
            ...ownProps,
            ...stateProps,
        }),
    )(TimeSlotSelector);

export const ConnectedTimeSlotSelector = connectTimeSlotSelector();

export default ConnectedTimeSlotSelector;
